<template>
  <nav class="top-0 z-150 flex items-center justify-between flex-wrap bg-white p-2 lg:px-3 shadow border-solid border-b-1">
    <div class="flex items-center flex-shrink-0 text-gray-800 mr-16">
      <span class="flex items-center sm:text-2xl md:text-3xl font-medium title-font md:mb-0 text-gray-700">
        <router-link :to="{ name: 'Home' }"
          >TransMAP
          <slot />
        </router-link>
      </span>
    </div>
    <div class="xl:hidden">
      <button class="text-gray-700 text-xl px-3 py-1" type="button" v-on:click="toggleNavbar()">
        <i class="fas fa-bars"></i>
      </button>
    </div>
    <div class="deskContent lg:flex lg:flex-grow items-center">
      <ul class="flex flex-col lg:flex-row list-none ml-auto">
        <li class="nav-item">
          <router-link
            :to="{ path: '/Map' }"
            class="px-3 py-2 flex items-center text-sm uppercase font-thin leading-snug text-gray-700 hover:opacity-75"
          >
            <i class="text-lg leading-lg text-gray-700 opacity-75 fas fa-map-location" /><span class="ml-2">Explorer</span>
          </router-link>
        </li>
        <li class="nav-item">
          <a
            class="px-3 py-2 flex items-center text-sm uppercase font-thin leading-snug text-gray-700 hover:opacity-75"
            href="https://castuofa.github.io/transmap/"
          >
            <i class="text-lg leading-lg text-gray-700 opacity-75 fas fa-book" /><span class="ml-2">Project Docs</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="px-3 py-2 flex items-center text-sm uppercase font-thin leading-snug text-gray-700 hover:opacity-75" :href="metaUrl">
            <i class="text-lg leading-lg text-gray-700 opacity-75 fas fa-microchip" /><span class="ml-2">Hub Api</span>
          </a>
        </li>
      </ul>
    </div>
  </nav>
  <ul class="bg-white shadow py-2 z-100" v-if="showMenu">
    <li class="nav-item">
      <router-link
        :to="{ path: '/map' }"
        class="px-3 py-2 flex items-center text-sm uppercase font-thin leading-snug text-gray-700 hover:opacity-75"
      >
        <i class="text-lg leading-lg text-gray-700 opacity-75 fas fa-map-location" /><span class="ml-2">Explorer</span>
      </router-link>
    </li>
    <li class="nav-item">
      <a
        class="px-3 py-2 flex items-center text-sm uppercase font-thin leading-snug text-gray-700 hover:opacity-75"
        href="https://castuofa.github.io/transmap/"
      >
        <i class="text-lg leading-lg text-gray-700 opacity-75 fas fa-book" /><span class="ml-2">Project Docs</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="px-3 py-2 flex items-center text-sm uppercase font-thin leading-snug text-gray-700 hover:opacity-75" :href="metaUrl">
        <i class="text-lg leading-lg text-gray-700 opacity-75 fas fa-microchip" /><span class="ml-2">Hub Api</span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'layout-navbar',
  data() {
    return {
      showMenu: false,
      metaUrl: process.env.VUE_APP_BASE_URL,
    }
  },
  methods: {
    toggleNavbar: function () {
      this.showMenu = !this.showMenu
    },
  },
}
</script>

<style>

@media all and (max-width: 810px) {
  .deskContent {
    display: none;
  }
  .phoneContent {
    display: block;
  }
}

</style>
